import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'am-basic-skeleton',
    templateUrl: './basic-skeleton.component.html',
    styleUrls: ['./basic-skeleton.component.scss'],
    standalone: true,
})
export class BasicSkeletonComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
